import instanceQuery from 'graphql/queries/supplier/PurchaseVatOnlyPostingPreviewQuery.graphql';
import fragment from 'graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';

const PurchaseVatOnlyPostingPreview = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default PurchaseVatOnlyPostingPreview;
